import React, { useState, useEffect } from "react";
import {
  Button,
  Box,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  Grid,
  Zoom,
  Stack,
  styled,
  Divider,
  Tooltip,
  tooltipClasses,
  IconButton,
} from "@mui/material";
import CircularProgress from "@mui/material/CircularProgress";
import { useTranslation } from "react-i18next";
import { makeStyles } from "@mui/styles";
import AddAPhotoOutlinedIcon from "@mui/icons-material/AddAPhotoOutlined";
// import CommonButton from "../../components/CustomComponents/Buttons/CommonButton";
import CommonButton from "../../../../../components/CustomComponents/Buttons/CommonButton";
import PictureModalCard from "./PictureModalCard";
import Compressor from "compressorjs";

const useStyles = makeStyles((theme) => ({
  formUpload: {
    height: "16rem",
    width: "28rem",
    maxWidth: "100%",
    textAlign: "center",
    position: "relative",
  },
  lableFileUpload: {
    height: " 100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    borderWidth: "2px",
    borderRadius: "1rem",
    borderStyle: "dashed",
    borderColor: "#cbd5e1",
    backgroundColor: "#f8fafc",
  },
  dragFile: {
    position: "absolute",
    width: "100%",
    height: "100%",
    borderRadius: "1rem",
    top: "0px",
    right: "0px",
    bottom: "0px",
    left: "0px",
  },
}));
const Transition = React.forwardRef((props, ref) => (
  <Zoom ref={ref} {...props} style={{ transitionDelay: "200ms" }} />
));

const CustomWidthTooltipOfDelete = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: "red",
  },
});
Transition.displayName = "Transition";

const Item = styled(Box)(({ theme }) => ({
  // backgroundColor: theme.palette.mode === "dark" ? "#1A2027" : "#fff",
  ...theme.typography.body2,
  padding: theme.spacing(1),
  // textAlign: "center",
  color: theme.palette.text.secondary,
}));

function CircularProgressWithLabel(props) {
  return (
    <Box sx={{ position: "relative", display: "inline-flex" }}>
      <CircularProgress variant="determinate" {...props} />
      <Box
        sx={{
          top: 0,
          left: 0,
          bottom: 0,
          right: 0,
          position: "absolute",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Typography
          variant="caption"
          component="div"
          color="text.secondary"
        >{`${Math.round(props.value)}%`}</Typography>
      </Box>
    </Box>
  );
}
const ProfilePictureModal = ({
  locationId,
  open,
  handleClose,
  setPostData,
  handleCloseNavigate,
  postData,
}) => {
  const inputFileRef = React.useRef();
  const classes = useStyles();
  const { t } = useTranslation();

  const [translation] = useTranslation("translation");
  const [picturePreview, setPicturePreview] = useState("");
  const [dragActive, setDragActive] = React.useState(false);
  const [isUploading, setIsUploading] = useState(false);
  const [selectedImages, setSelectedImages] = useState([]);
  const [progress, setProgress] = useState(0);

  const [compressedFile, setCompressedFile] = useState([]);

  useEffect(() => {
    if (!open) {
      setPicturePreview("");
    }
  }, [open]);

  const selectImage = () => {
    if (inputFileRef?.current) {
      inputFileRef?.current?.click();
    }
  };

  const handleDelete = (index) => {
    const deleteImage = selectedImages.filter((item, indx) => {
      return indx !== index;
    });
    const findDeleted = selectedImages.find((item, indx) => {
      return indx === index;
    });
    if (findDeleted) {
      const filterDelete = postData.filter((item) => {
        return item["postPictures"][0]["key"] === findDeleted.key;
      });
      setPostData(filterDelete);
    }
    setSelectedImages(deleteImage);
  };
  const handleImageError = (index) => {
    let temmpArray = [...selectedImages];
    let temmpObj = temmpArray[index];
    temmpObj["error"] = true;
    temmpArray[index] = temmpObj;
    setSelectedImages(temmpArray);
  };
  const afterUploadSelectedChange = (index, key) => {
    const tempArray = [...selectedImages];
    const tempObj = selectedImages[index];
    tempObj["key"] = key;
    tempArray.splice(index, 1, tempObj);
    setSelectedImages(tempArray);
  };

  /*  const onFileChangeCapture = (e) => {
    let tempImages = [];
    for (const [key, value] of Object.entries(e.target.files)) {
      if (key !=="length") {
        tempImages.push({
          picture: value,
          picturePreview: URL.createObjectURL(value),
        });
      }
    }

    setSelectedImages(tempImages);

    // if (e.target.files[0]) {
    //   const objectURL = URL.createObjectURL(e.target.files[0]);
    //   setPicturePreview(objectURL);
    //   setPicture(e.target.files[0]);
    // }
  }; */
  const onFileChangeCapture = (e) => {
    let tempImages = [];
    /*   for (const [key, value] of Object.entries(e.target.files)) {
      if (key !=="length") {
        tempImages.push({
          picture: value,
          picturePreview: URL.createObjectURL(value),
        });
      }
    }
    setSelectedImages(tempImages); */
    for (const [key, value] of Object.entries(e?.target?.files)) {
      new Compressor(value, {
        quality: 0.8, // 0.6 can also be used, but its not recommended to go below.
        success: (compressedResult) => {
          // compressedResult has the compressed file.
          // Use the compressed file to upload the images to your server.
          setCompressedFile(compressedResult);

          tempImages.push({
            picture: compressedResult,
            picturePreview: URL.createObjectURL(compressedResult),
          });
          setSelectedImages([...tempImages]);
        },
      });
    }

    /*   const image = e.target.files[0];
    new Compressor(image, {
      quality: 0.8, // 0.6 can also be used, but its not recommended to go below.
      success: (compressedResult) => {
        // compressedResult has the compressed file.
        // Use the compressed file to upload the images to your server.
        setCompressedFile(compressedResult);

        tempImages.push({
          picture: compressedResult,
          picturePreview: URL.createObjectURL(compressedResult),
        });
        setSelectedImages(tempImages);
      },
    }); */
  };

  const handleDrag = function (e) {
    e.preventDefault();
    e.stopPropagation();
    if (e.type === "dragenter" || e.type === "dragover") {
      setDragActive(true);
    } else if (e.type === "dragleave") {
      setDragActive(false);
    }
  };
  /*  const handleDrop = function (e) {
    e.preventDefault();
    e.stopPropagation();
    setDragActive(false);

    if (e.dataTransfer.files) {
      let tempImages = [];
      for (const [key, value] of Object.entries(e.dataTransfer.files)) {
        if (
          key !=="length" &&
          value &&
          !value?.type?.toLowerCase()?.includes("video")
        ) {
          tempImages.push({
            picture: value,
            picturePreview: URL.createObjectURL(value),
          });
        }
      }
      setSelectedImages(tempImages);
    }
  }; */
  const handleDrop = function (e) {
    e.preventDefault();
    e.stopPropagation();
    setDragActive(false);
    let tempImages = [];

    for (const [key, value] of Object.entries(e?.dataTransfer?.files)) {
      new Compressor(value, {
        quality: 0.8, // 0.6 can also be used, but its not recommended to go below.
        success: (compressedResult) => {
          // compressedResult has the compressed file.
          // Use the compressed file to upload the images to your server.
          setCompressedFile(compressedResult);

          tempImages.push({
            picture: compressedResult,
            picturePreview: URL.createObjectURL(compressedResult),
          });
          setSelectedImages([...tempImages]);
        },
      });
    }
    /*   if (e.dataTransfer.files) {
      let tempImages = [];
      const image = e.dataTransfer.files[0];
      new Compressor(image, {
        quality: 0.8, // 0.6 can also be used, but its not recommended to go below.
        success: (compressedResult) => {
          // compressedResult has the compressed file.
          // Use the compressed file to upload the images to your server.
          setCompressedFile(compressedResult);

          tempImages.push({
            picture: compressedResult,
            picturePreview: URL.createObjectURL(compressedResult),
          });
          setSelectedImages(tempImages);
        },
      });

        for (const [key, value] of Object.entries(e.dataTransfer.files)) {
        if (
          key !=="length" &&
          value &&
          !value?.type?.toLowerCase()?.includes("video")
        ) {
          tempImages.push({
            picture: value,
            picturePreview: URL.createObjectURL(value),
          });
        }
      }
      //  setSelectedImages(tempImages);
    } */
  };

  return (
    <>
      <Dialog
        open={open}
        disableBackdropClick
        sx={{
          "& .MuiDialog-container": {
            "& .MuiPaper-root": {
              width: "100%",
              // height: "100%",
              maxWidth: "800px", // Set your width here
              // maxHeight: "480px",
              borderRadius: "8px",
            },
          },
        }}
        TransitionComponent={Transition}
        keepMounted
        onClose={handleCloseNavigate}
        fullWidth
        aria-labelledby="alert-dialog-slide-title"
        aria-describedby="alert-dialog-slide-description"
      >
        {selectedImages?.length > 0 ? (
          <>
            <Stack
              direction="row"
              justifyContent="space-between"
              alignItems="center"
            >
              <DialogTitle
                sx={{
                  color: "#1B2430",
                  fontSize: "20px",
                  marginBottom: "20px",
                  fontWeight: "700",
                }}
                id="alert-dialog-slide-title"
              >
                {t("Uploading_Images")}
              </DialogTitle>
              <IconButton
                onClick={() => handleCloseNavigate()}
                aria-label="save"
                hover="none"
                sx={{
                  hover: "none",
                  marginBottom: "15px",
                  marginRight: "22px",
                }}
              >
                X
              </IconButton>
            </Stack>

            <DialogContent>
              <Stack direction="column">
                <Item>
                  {selectedImages && (
                    <>
                      {selectedImages?.map((img, index) => {
                        return (
                          <PictureModalCard
                            img={img}
                            handleDelete={handleDelete}
                            locationId={locationId}
                            setPostData={setPostData}
                            handleClose={handleClose}
                            index={index}
                            isUploading={isUploading}
                            setIsUploading={setIsUploading}
                            postData={postData}
                            afterUploadSelectedChange={
                              afterUploadSelectedChange
                            }
                            handleImageError={handleImageError}
                          />
                        );
                      })}
                    </>
                  )}
                </Item>

                <Divider />
                <Item
                  sx={{
                    paddingTop: "24px",
                    display: "flex",
                    justifyContent: "flex-end",
                    flex: 1,
                  }}
                >
                  {selectedImages?.length > 0 && (
                    <>
                      <Button
                        sx={{
                          fontWeight: "700",
                          size: "large",
                          color: "#1B2430",
                          borderRadius: "8px",
                          padding: " 14px 20px",
                          border: "1px solid #E0E0E0",
                          hover: "none",
                        }}
                        variant="outlined"
                        // color="#1B2430"

                        onClick={() => handleCloseNavigate()}
                      >
                        {t("Cancel")}
                      </Button>
                      &nbsp; &nbsp;
                      <CommonButton
                        disabled={
                          selectedImages.find((item) => item?.error === true)
                            ? true
                            : postData?.length === selectedImages?.length ||
                              !isUploading
                            ? false
                            : true
                        }
                        onSubmit={() =>
                          postData?.length === selectedImages?.length
                            ? handleClose()
                            : setIsUploading(true)
                        }
                        label={
                          postData?.length === selectedImages?.length
                            ? t("Submit")
                            : "Upload"
                        }
                      />
                    </>
                  )}
                </Item>
              </Stack>
            </DialogContent>
          </>
        ) : (
          <>
            <Stack
              direction="row"
              justifyContent="space-between"
              alignItems="center"
            >
              <DialogTitle
                id="alert-dialog-slide-title"
                sx={{
                  fontWeight: "700",
                  color: "#1B2430",
                  fontSize: "20px",
                  letterSpacing: "0.5px",
                  lineHeight: "28px",
                }}
              >
                {t("Uploading_Images")}
              </DialogTitle>
              <IconButton
                onClick={() => handleCloseNavigate()}
                aria-label="save"
                hover="none"
                sx={{ hover: "none", marginRight: "22px" }}
              >
                X{/* <Cancel /> */}
              </IconButton>
            </Stack>

            <DialogContent>
              <Stack direction="column">
                {/* <Item sx={{ marginY: "24px", fontSize: "20px", color: "#1B2430" }}>
            <Typography variant="h6">Upload Images</Typography>
          </Item> */}
                <Item>
                  <Box
                    sx={{
                      p: 2,
                      /*    border: "2px dashed #E0E0E0", */
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      justifyContent: "center",
                      height: "70vh",
                    }}
                  >
                    <form
                      className={classes.formUpload}
                      onDragEnter={handleDrag}
                      onSubmit={(e) => e.preventDefault()}
                    >
                      <label className={classes.lableFileUpload} for="file">
                        <AddAPhotoOutlinedIcon
                          sx={{
                            height: "79.38px",
                            width: "91.67px",
                            cursor: "pointer",
                            color: "#8D9298",
                          }}
                        />
                        <input
                          id="file"
                          type="file"
                          accept="image/*"
                          multiple={true}
                          ref={inputFileRef}
                          onChange={onFileChangeCapture}
                          style={{ display: "none" }}
                        />
                      </label>
                      {dragActive && (
                        <div
                          className={classes.dragFile}
                          onDragEnter={handleDrag}
                          onDragLeave={handleDrag}
                          onDragOver={handleDrag}
                          onDrop={handleDrop}
                        ></div>
                      )}
                    </form>
                    <Typography
                      sx={{
                        fontSize: "1rem",
                        marginTop: "26px",
                        fontWeight: "400",
                        color: "#495059",
                      }}
                    >
                      {t("Uploading_Images_Text")}
                    </Typography>
                  </Box>
                </Item>
              </Stack>
            </DialogContent>
          </>
        )}

        <DialogActions>
          <Grid container display="flex" justifyContent="space-between"></Grid>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default ProfilePictureModal;
